import { CollectionType } from '@/enums/collection-type';
import { WebLocale } from '@/enums/web-locale';
import { Watchlist } from '@/lazy-load-components';
import { RouteConfig } from 'vue-router';

export const rentalListLocales = [WebLocale.au, WebLocale.nz] as const;

type RentalListLocale = (typeof rentalListLocales)[number];

const isRentalListLocale = (locale: WebLocale) => {
	return rentalListLocales.includes(locale as RentalListLocale);
};

export function makeRentalListRoutes(currentLocale: WebLocale): RouteConfig[] {
	const routes: RouteConfig[] = [];

	if (isRentalListLocale(currentLocale)) {
		routes.push(makeRentalListsRoute(currentLocale as RentalListLocale));
	}

	return routes;
}

function makeRentalListsRoute(currentLocale: RentalListLocale): RouteConfig {
	return {
		name: 'app.titles.my-rentals.list',
		path: `/${currentLocale}/lists/my-rentals`,
		component: Watchlist,
		meta: {
			collectionType: CollectionType.MY_RENTALS,
			tab: 'lists',
			hasFilterBar: false,
		},
	};
}
